// extracted by mini-css-extract-plugin
export default {"text":"text--KCJBa","collapsed":"collapsed--rk5TN"};